/*eslint-disable*/
window.enableVoiceRecognition = async function enableVoiceRecognition(
  setVoiceBtnContent,
  setBannerStatus,
  setShowLottie,
  lang
) {
  const micIcon = (await import("@/app/assets/vectors/MicIcon")).default;
  const noMicIcon = (await import("@/app/assets/vectors/NoMicIcon")).default;
  (window.jQuery = require("jquery")),
    (window.$ = window.jQuery),
    (function (e) {
      e(document).ready(function () {
        var run_onend = true;
        var t = window.chrome,
          n = window.navigator,
          r = n.vendor,
          a = void 0 !== window.opr,
          i = n.userAgent.indexOf("Edg") > -1;
        (null != t && "Google Inc." === r && !1 === a && !1 === i) ||
          (setVoiceBtnContent({
            label: "Voice Typing",
            disabled: true,
            icon: noMicIcon,
          }),
          setShowLottie(false),
          setBannerStatus("no-support"));
        void 0 != window.navigator.brave &&
          "isBrave" == window.navigator.brave.isBrave.name &&
          (setVoiceBtnContent({
            label: "Voice Typing",
            disabled: true,
            icon: noMicIcon,
          }),
          setShowLottie(false),
          setBannerStatus("no-support"));
        try {
          var o = new webkitSpeechRecognition();
        } catch (l) {
          var o = Object;
        }
        var s = !1;
        (o.continuous = !1), (o.interimResults = !0), (o.lang = lang);
        var c = "",
          u = e("#input-field"),
          v = "input-field";
        function d() {
          if (s) {
            o.stop(),
              (s = !1),
              e("#voice-type--button")
                .removeClass("bg-red-400")
                .addClass("bg-primary"),
              u.unbind("keydown", f);
            return;
          }
          (s = !0),
            setVoiceBtnContent({
              label: "End Listening",
              disabled: false,
              bgColor: "var(--opq-orange-20)",
            }),
            setShowLottie(true),
            u.focus(),
            u.keydown(f),
            o.start();
        }
        function f(e) {
          e.preventDefault();
        }
        function g(t) {
          var n = document.getElementById("input-field").selectionStart;
          let r = e("#input-field").val(),
            a = t;
          if (" " === r[n - 1]) var i = r.slice(0, n - 1) + a + r.slice(n);
          else var i = r.slice(0, n) + a + r.slice(n);
          e("input-field").val(i);
        }
        e("#voice-type--button").click(d),
          (o.onerror = function (e) {
            if (e.error == "not-allowed") {
              run_onend = false;
              setVoiceBtnContent({
                label: "Voice Typing",
                disabled: true,
                icon: noMicIcon,
              }),
                setShowLottie(false),
                setBannerStatus("no-permission");
            }
          }),
          (o.onresult = function (e) {
            !(function e(t) {
              var n = u.getCursorPosition() - c.length;
              var replace = [
                  "ൻറ",
                  "ൻറാ",
                  "ൻറി",
                  "ൻറീ",
                  "ൻറു",
                  "ൻറൂ",
                  "ൻറെ",
                  "ൻറേ",
                  "ൻറൈ",
                  "ൻറൊ",
                  "ൻറോ",
                  "ൻറൗ",
                  "ൻറ്",
                ],
                by = [
                  "ന്റ",
                  "ന്റാ",
                  "ന്റി",
                  "ന്റീ",
                  "ന്റു",
                  "ന്റൂ",
                  "ന്റെ",
                  "ന്റേ",
                  "ന്റൈ",
                  "ന്റൊ",
                  "ന്റോ",
                  "ന്റൗ",
                  "ന്റ്",
                ];
              u.val(u.val().replace(c, "")), (c = ""), u.setCursorPosition(n);
              for (var r = t.resultIndex; r < t.results.length; ++r)
                if (t.results[r].isFinal) {
                  for (
                    var a = t.results[r][0].transcript + " ", r = 0;
                    r < replace.length;
                    r++
                  )
                    a = a.replace(RegExp(replace[r], "g"), by[r]);
                  insertAtCaret(v, a);
                } else
                  (isFinished = !1),
                    insertAtCaret(v, t.results[r][0].transcript + "​"),
                    (c += t.results[r][0].transcript + "​");
            })(e);
          }),
          (o.onend = function () {
            run_onend &&
              setVoiceBtnContent({
                label: "Voice Typing",
                icon: micIcon,
                disabled: false,
                bgColor: "var(--clr-white)",
              }),
              setShowLottie(false),
              (s = !1),
              u.unbind("keydown", f);
          });
      });
    })(jQuery),
    (function (e) {
      (insertAtCaret = function (e, t) {
        var n = document.getElementById(e),
          r = n.scrollTop,
          a = 0,
          i =
            n.selectionStart || "0" == n.selectionStart
              ? "ff"
              : !!document.selection && "ie";
        if ("ie" == i) {
          n.focus();
          var o = document.selection.createRange();
          o.moveStart("character", -n.value.length), (a = o.text.length);
        } else "ff" == i && (a = n.selectionStart);
        var l = n.value.substring(0, a),
          s = n.value.substring(a, n.value.length);
        (n.value = l + t + s),
          (a += t.length),
          "ie" == i
            ? (n.focus(),
              (o = document.selection.createRange()).moveStart(
                "character",
                -n.value.length
              ),
              o.moveStart("character", a),
              o.moveEnd("character", 0),
              o.select())
            : "ff" == i &&
              ((n.selectionStart = a), (n.selectionEnd = a), n.focus()),
          (n.scrollTop = r);
      }),
        (e.fn.getCursorPosition = function () {
          var t = e(this).get(0),
            n = 0;
          if ("selectionStart" in t) n = t.selectionStart;
          else if ("selection" in document) {
            t.focus();
            var r = document.selection.createRange(),
              a = document.selection.createRange().text.length;
            r.moveStart("character", -t.value.length), (n = r.text.length - a);
          }
          return n;
        }),
        (e.fn.setCursorPosition = function (t) {
          if (e(this).get(0).setSelectionRange)
            e(this).get(0).setSelectionRange(t, t);
          else if (e(this).get(0).createTextRange) {
            var n = e(this).get(0).createTextRange();
            n.collapse(!0),
              n.moveEnd("character", t),
              n.moveStart("character", t),
              n.select();
          }
        });
    })(jQuery);
};
